import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const AiInvoiceAnalysis = lazy(() => import("@/pages/AiInvoiceAnalysis"));

export const Route = createFileRoute("/ai-fakturaanalys")({
  head: () => seoHead("/ai-fakturaanalys"),
  component: () => <AiInvoiceAnalysis />,
});
